import useMediaQuery from '@material-ui/core/useMediaQuery';
import {useTheme} from '@material-ui/core/styles';

export const useMobileLayout = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
};
